<template>
  <div class="flex flex-wrap -mx-1">
    <DeleteConfirmButton
      class="px-4 relative group hover:text-red-600 m-1 bg-gray-200 text-xs font-semibold rounded-full text-gray-800 py-1 whitespace-no-wrap flex items-center"
      v-for="tag in tags"
      :key="tag.id"
      :message="`Tag '${tag.name}' verwijderen?`"
      @confirm="deleteTag(tag)"
    >
      <span>{{ tag.name }}</span>
      <BaseIcon
        name="trash-2"
        size="16"
        stroke="3"
        class="absolute invisible group-hover:visible left-0 -ml-2"
      />
    </DeleteConfirmButton>
    <ModalButton
      class="px-3 hover:border-blue-600 hover:bg-blue-600 hover:text-white m-1 bg-gray-200 text-xs font-semibold rounded-full text-gray-800 py-1 whitespace-no-wrap flex items-center"
      size="max-w-xl"
    >
      <template v-slot:button>
        <BaseIcon name="plus" size="14" stroke="3" />
        <span class="mx-1">Tag toevoegen</span>
      </template>
      <ContactTagForm
        :action="`/json/contacts/${$route.params.id}/tags`"
        :used="tags"
        @success="success"
      />
    </ModalButton>
  </div>
</template>

<script>
import { destroy } from "@/api";
import ContactTagForm from "./ContactTagForm";
import DeleteConfirmButton from "./DeleteConfirmButton";

export default {
  props: {
    tags: Array
  },

  components: {
    ContactTagForm,
    DeleteConfirmButton
  },

  methods: {
    success(data) {
      this.$emit("success", data);
    },

    deleteTag(tag) {
      let contactId = this.$store.state.contact.id;

      destroy(`/contacts/${contactId}/tags/${tag.id}`).then(response =>
        this.$store.commit("SET_CONTACT", response.data)
      );
    }
  }
};
</script>
